/*
 * File: Error.jsx
 * Project: interactive-city-app
 *
 * Created by Brendan Michaelsen on January 31, 2022 at 10:50 PM
 * Copyright © 2022 Lithios, LLC. All rights reserved.
 *
 * Last Modified: June 11, 2024 at 11:20 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

// Utilities
import { createStateLocale } from '../../../../utilities/locale';

// Slices
import { clearCityApp } from '../../../../store/slices/cityApp/cityApp.slice';

// Components
import {
	Meta, ErrorComponent
} from '../../../../components';

// Styles
import * as S from './Error.styles';


/**
 * Component
 */

const Error = ({ meta, locale }) => {

	// Get current locale from hook
	const clientLocale = useSelector((state) => state.locale.value);
	const stateLocale = createStateLocale(clientLocale, locale);

	// Use hooks
	const dispatch = useDispatch();

	// Handle component initialization
	useEffect(() => {

		// Clear city app
		dispatch(clearCityApp());

	}, []);

	// Render component
	return (
		<>
			{/* Meta */}
			<Meta meta={meta} locale={stateLocale} />

			{/* Component Content */}
			<S.Wrapper>
				<S.ContentPadding left right dynamic>

					{/* Error Component */}
					<ErrorComponent className="fullComponent lightContent" />

					{/* Decoration */}
					<S.Decoration src={`${process.env.CDN_URL}/public/assets/building-decoration-white-extended.png`} />

				</S.ContentPadding>
			</S.Wrapper>
		</>
	);
};


/**
 * Configuration
 */

Error.propTypes = {
	meta: PropTypes.shape(),
	locale: PropTypes.shape(),
};
Error.defaultProps = {
	meta: {},
	locale: {}
};


/**
 * Exports
 */

export default Error;
